import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithIntercept } from "src/utils/rtkQueryBaseQueryUtil";
import downloadBlobResponse from "src/utils/downloadBlobResponse";

const serverIp = process.env.REACT_APP_SERVER_IP;

// 이행매장 엑셀 템플릿 기본 파일명 (Content-Disposition 추출 실패 시)
const EXCEL_TEMPLATE_DEFAULT_FILENAME = "이행매장_업로드_템플릿.xlsx";
// 이행평가 피드백 업로드 템플릿 기본 파일명 (Content-Disposition 추출 실패 시)
const EXECUTE_FEEDBACK_TEMPLATE_DEFAULT_FILENAME = "이행평가_피드백_업로드_템플릿.xlsx";

export const noticeAPI = createApi({
  baseQuery: baseQueryWithIntercept,
  refetchOnMountOrArgChange: true,
  tagTypes: ["noticeVo"],
  reducerPath: "noticeAPI",
  endpoints: (builder) => ({
    getS3Url: builder.mutation({
      query: ({ data }) => ({
        url: `common/s3-upload-url/attachment`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    addNotice: builder.mutation({
      query: (data) => ({
        url: `notice`,
        method: "POST",
        headers: {
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    modifyNotice: builder.mutation({
      query: ({ notice_idx, data }) => ({
        url: `notice/${notice_idx}`,
        method: "PUT",
        headers: {
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    // ========================= notice 목록 =========================
    noticeList: builder.query({
      query: (search) => ({
        url: `/notice/search`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        params: search,
      }),
    }),
    // ========================= notice 목록(고정) =========================
    noticePinList: builder.query({
      query: () => ({
        url: `/notice/important-notice`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
    getGroupStore: builder.query({
      query: ({ groupId, queryString }) => ({
        url: `/users/group/${groupId}/store`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        params: queryString,
      }),
      transformResponse: (response: any) => response.data,
    }),
    getNotice: builder.mutation({
      query: (noticeIdx) => ({
        url: `notice/${noticeIdx}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    getImportantNoticeCount: builder.query({
      query: () => ({
        url: "notice/important-notice-count",
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    deleteNotice: builder.mutation({
      query: (noticeIdx) => ({
        url: `notice/${noticeIdx}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => {
        console.log(1);
        response.data;
      },
    }),
    getNoticeDetail: builder.query({
      query: (noticeIdx) => ({
        url: `notice/${noticeIdx}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    changeStores: builder.mutation({
      query: ({ noticeIdx, data }) => ({
        url: `notice/${noticeIdx}/store`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
      transformResponse: (response: any) => response,
    }),
    getFulfillData: builder.mutation({
      query: (fullfillIdx) => ({
        url: `notice/execute/${fullfillIdx}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    fulfillRegister: builder.mutation({
      query: ({ fullfillIdx, data }) => ({
        url: `notice/execute/${fullfillIdx}`,
        method: "POST",
        headers: {
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
      transformResponse: (response: any) => response,
    }),
    fulfillModify: builder.mutation({
      query: ({ fullfillIdx, data }) => ({
        url: `notice/execute/${fullfillIdx}`,
        method: "PUT",
        headers: {
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
      transformResponse: (response: any) => response,
    }),
    deleteComment: builder.mutation({
      query: (comment_idx) => ({
        url: `common/comment/${comment_idx}`,
        method: "DELETE",
      }),
      transformResponse: (response: any) => response,
    }),
    getOftenUsePhrases: builder.query({
      query: () => ({
        url: `notice/often-use-phrase`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    addOftenUsePhrase: builder.mutation({
      query: (data) => ({
        url: `notice/often-use-phrase`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
      transformResponse: (response: any) => response,
    }),
    updateOftenUsePhrase: builder.mutation({
      query: (data) => ({
        url: `notice/often-use-phrase`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
      transformResponse: (response: any) => response,
    }),
    deleteOftenUsePhrase: builder.mutation({
      query: (data) => ({
        url: `notice/often-use-phrase`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
      transformResponse: (response: any) => response,
    }),
    getCurrentFulfill: builder.query({
      query: (noticeIdx) => ({
        url: `/notice/${noticeIdx}/board`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
    getFulfilExcel: builder.mutation({
      query: (fullfillIdx) => ({
        url: `notice/${fullfillIdx}/fulfilment`,
        method: "GET",
        // Content-Disposition 파일명으로 저장 (추출 실패 시 download.xlsx)
        responseHandler: (response) => downloadBlobResponse(response, "download.xlsx"),
        headers: {
          "Content-Type": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    // ========================= 이행매장 엑셀 업로드 (VMD-392) =========================
    // 매칭·검증은 서버가 수행. 성공 시 HTTP 200, 매칭 결과만 반환하고 서버에 저장하지 않는다.
    // FormData 전송이므로 Content-Type 을 직접 지정하지 않는다 (multipart boundary 유지).
    excelUpload: builder.mutation<ExcelUploadResult, FormData>({
      query: (formData) => ({
        url: `notice/store/excel-upload`,
        method: "POST",
        headers: {},
        body: formData,
      }),
      transformResponse: (response: any) => response.data,
    }),
    // ========================= 이행평가 피드백 엑셀 미리보기 / 등록 (VMD-389) =========================
    // 같은 파일을 미리보기와 등록에 각각 올린다(서버는 상태를 들고 있지 않음). verdicts 는 판정 값의 JSON 배열 문자열.
    previewExecuteFeedback: builder.mutation<ExecuteFeedbackPreview, { notice_idx: string; formData: FormData }>({
      query: ({ notice_idx, formData }) => ({
        url: `notice/${notice_idx}/execute/feedback/preview`,
        method: "POST",
        headers: {},
        body: formData,
      }),
      transformResponse: (response: any) => response.data,
    }),
    registerExecuteFeedback: builder.mutation<ExecuteFeedbackRegisterResult, { notice_idx: string; formData: FormData }>({
      query: ({ notice_idx, formData }) => ({
        url: `notice/${notice_idx}/execute/feedback`,
        method: "POST",
        headers: {},
        body: formData,
      }),
      transformResponse: (response: any) => response.data,
    }),
    // ========================= 이행매장 엑셀 템플릿 다운로드 (VMD-392) =========================
    // 매장명/매장코드 헤더만 있는 빈 xlsx. 파일명은 Content-Disposition 헤더에서 추출한다.
    excelTemplate: builder.mutation<void, void>({
      query: () => ({
        url: `notice/store/excel-template`,
        method: "GET",
        responseHandler: (response) => downloadBlobResponse(response, EXCEL_TEMPLATE_DEFAULT_FILENAME),
        headers: {
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, */*",
        },
      }),
    }),
    // ========================= 이행평가 피드백 템플릿 다운로드 (VMD-404) =========================
    // DATA_UPLOAD 시트에 헤더만 있는 빈 xlsx. 파일명은 Content-Disposition 헤더에서 추출한다.
    executeFeedbackTemplate: builder.mutation<void, void>({
      query: () => ({
        url: `notice/execute/feedback/excel-template`,
        method: "GET",
        responseHandler: (response) => downloadBlobResponse(response, EXECUTE_FEEDBACK_TEMPLATE_DEFAULT_FILENAME),
        headers: {
          Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, */*",
        },
      }),
    }),
  }),
});

export const {
  useGetS3UrlMutation,
  useAddNoticeMutation,
  useGetGroupStoreQuery,
  useGetNoticeMutation,
  useModifyNoticeMutation,
  useChangeStoresMutation,
  useNoticeListQuery,
  useNoticePinListQuery,
  useGetNoticeDetailQuery,
  useDeleteNoticeMutation,
  useFulfillRegisterMutation,
  useGetFulfillDataMutation,
  useFulfillModifyMutation,
  useGetCurrentFulfillQuery,
  useGetImportantNoticeCountQuery,
  useGetFulfilExcelMutation,
  useDeleteCommentMutation,
  useGetOftenUsePhrasesQuery,
  useAddOftenUsePhraseMutation,
  useUpdateOftenUsePhraseMutation,
  useDeleteOftenUsePhraseMutation,
  useExcelUploadMutation,
  useExcelTemplateMutation,
  usePreviewExecuteFeedbackMutation,
  useRegisterExecuteFeedbackMutation,
  useExecuteFeedbackTemplateMutation,
} = noticeAPI;
